import { env } from '../../../../env'
import axios from 'axios'
import { ClientInfoResponse, ClientListFilterType, ClientListResponse, ClientRequisiteId, ClientRoutingResponse, CreateClientRequest } from './_rest_models'
import { ROLE, UserModel } from '../../auth'
import { getUserRolesByHierarchy } from '../../auth/PrivateRoute'
import {
  ClientEditRequest,
  IClientItem,
  MatchingPayoutRestrictionRequest,
  RiskScoreChangeRequest,
  TemporaryRiskScoreChangeRequest,
} from './_models'
import { IClientsExportRequest } from '../../../../components/ClientsSearch/ClientsSearch.types'

const API_URL = env.REACT_APP_API_URL

export const GET_EMPLOYEE_LIST_CLIENTS = `${API_URL}/api/internal/external_user/list`
export const GET_LIST_CLIENTS = `${API_URL}/api/external_user/list`
export const GET_EMPLOYEE_CLIENT_INFO = `${API_URL}/api/internal/external_user/__token__`
export const GET_CLIENT_INFO = `${API_URL}/api/external_user/__token__`
export const EDIT_CLIENT = `${API_URL}/api/internal/external_user/edit/__token__`
export const CLIENTS_EXPORT = `${API_URL}/api/internal/reports/external-users`
export const CREATE_CLIENT = `${API_URL}/api/internal/external_user/create`
export const DETACH_PAYMENT_REQUISITE = `${API_URL}/api/internal/external_user/__token__/payment-requisite/__requisite_id__`
export const CHANGE_RISK_SCORE = `${API_URL}/api/internal/external_user/__token__/risk-score`
export const CHANGE_TEMPORARY_RISK_SCORE = `${API_URL}/api/internal/external_user/__token__/risk-score/temporary`
export const CHANGE_MATCHING_PAYOUT_RESTRICTION = `${API_URL}/api/internal/external_user/__token__/matching-payout-restriction`
export const GET_CLIENT_ROUTING = `${API_URL}/api/internal/external_user/routing/__token__`

export function getListClientsForSearch(
  filterData: Partial<ClientListFilterType>,
  currentUser?: UserModel
) {
  if (!filterData.perPage) {
    filterData.perPage = 99
  }

  if (!filterData.page) {
    filterData.page = 1
  }

  let params: any = { ...filterData }
  params.requisiteId = filterData.requisiteId?.map((el: ClientRequisiteId) => el.id)

  const allRolesCurrentUser = getUserRolesByHierarchy(currentUser)
  const url = (allRolesCurrentUser.includes(ROLE.ROLE_EMPLOYEE) || allRolesCurrentUser.includes(ROLE.ROLE_MERCHANT_MANAGER))
    ? GET_EMPLOYEE_LIST_CLIENTS
    : GET_LIST_CLIENTS

  return axios.get<Partial<ClientListResponse>>(url, {
    params: params,
  })
}

export function getClientByToken(token: string, currentUser?: UserModel) {
  const allRolesCurrentUser = getUserRolesByHierarchy(currentUser)
  const url = (allRolesCurrentUser.includes(ROLE.ROLE_EMPLOYEE) || allRolesCurrentUser.includes(ROLE.ROLE_MERCHANT_MANAGER))
    ? GET_EMPLOYEE_CLIENT_INFO
    : GET_CLIENT_INFO

  return axios.get<Partial<ClientInfoResponse>>(url.replace('__token__', token))
}

export function editClientByToken(token: string, updateData: ClientEditRequest) {
  return axios.post<Partial<ClientInfoResponse>>(
    EDIT_CLIENT.replace('__token__', token),
    updateData
  )
}

export function postClientsExport(query: IClientsExportRequest) {
  return axios.post<Partial<ClientInfoResponse>>(CLIENTS_EXPORT, query, {
    responseType: 'blob',
  })
}

export function createClient(data: CreateClientRequest) {
  return axios.post<ClientInfoResponse>(CREATE_CLIENT, data)
}

export function changeRiskScore(token: string, data: RiskScoreChangeRequest) {
  return axios.patch<Partial<ClientInfoResponse>>(
    CHANGE_RISK_SCORE.replace('__token__', token),
    data
  )
}

export function changeTemporaryRiskScore(token: string, data: TemporaryRiskScoreChangeRequest) {
  return axios.put<Partial<ClientInfoResponse>>(
    CHANGE_TEMPORARY_RISK_SCORE.replace('__token__', token),
    data
  )
}

export function changeMatchingPayoutRestriction(token: string, data: MatchingPayoutRestrictionRequest) {
  return axios.put<Partial<ClientInfoResponse>>(
    CHANGE_MATCHING_PAYOUT_RESTRICTION.replace('__token__', token),
    data
  )
}

export function detachPaymentRequisite(userToken: string, requisiteId: number) {
  const url = DETACH_PAYMENT_REQUISITE
    .replace('__token__', userToken)
    .replace('__requisite_id__', requisiteId.toString())

  return axios.delete<ClientInfoResponse>(url)
}

export function getClientRouting(token: string) {
  return axios.get<ClientRoutingResponse>(GET_CLIENT_ROUTING.replace('__token__', token))
}
